<script>
import { cn } from '@/lib/utils'

export default {
  name: 'UiCardContent',
  inheritAttrs: false,
  setup(props, { attrs }) {
    const getClass = () => {
      return cn('p-6 pt-0', attrs.class ?? '')
    }

    return {
      getClass
    }
  }
}
</script>

<template>
  <div :class="getClass()">
    <slot></slot>
  </div>
</template>
